import { Controller } from "@hotwired/stimulus"
import "whatwg-fetch"

export default class extends Controller {
  static targets = ["negative", "neutral", "positive", "message", "feedback", "selectors", "rating"]

  connect() {
    this.ratingTarget.value = this.data.get("rating")
    this.render()
  }

  render = () => {
    this.negativeTarget.classList = ""
    this.neutralTarget.classList = ""
    this.positiveTarget.classList = ""

    const rating = parseInt(this.ratingTarget.value)

    if (rating == -1) {
      this.negativeTarget.classList.add("selected")
      this.messageTarget.innerHTML = "Yikes, what went wrong?"
    } else if (rating == 0) {
      this.neutralTarget.classList.add("selected")
      this.messageTarget.innerHTML = "What could have been better?"
    } else if (rating == 1) {
      this.positiveTarget.classList.add("selected")
      this.messageTarget.innerHTML = "Have any suggestions for improvement?"
    }

    if (rating >= -1 && rating <= 1) {
      this.feedbackTarget.classList.add("show")
      this.selectorsTarget.classList.add("feedback-selected")
    }
  }

  selectNegative = (event) => {
    event.preventDefault()
    this.setRating(-1)
  }

  selectNeutral = (event) => {
    event.preventDefault()
    this.setRating(0)
  }

  selectPositive = (event) => {
    event.preventDefault()
    this.setRating(1)
  }

  setRating = (value) => {
    this.ratingTarget.value = value
    this.render()
    const url = `${location.href}.json`
    const body = {
      rating: value
    }
    fetch(url, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
  }
}
